module.exports = __webpack_public_path__ + "static/training-b8da863d90f79f7c4d25670e15cee7ab.mp4";